export default "__VITE_ASSET__r8Y627HS__"